"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DEFAULT_VALUES = {
    application_fee: 0.0,
    program_fees: 0.0,
    tuition_cost: 0.0,
    discounts: 0.0,
    transfered_hours: 0.0,
    kit: 0.0,
    opt_out_total: 0.0,
    strf: 0.0,
    total_charges: 0.0,
    total_program: 0.0,
    total_enrollment: 0.0,
    percentageRate: 0,
    financeCharge: 0.0,
    creditsSteps: 0.0,
    totalPayments: 0.0,
    downPayments: 0.0,
    amount_of_deposit: 0.0,
    terms_start: ""
};
exports.DEFAULT_VALUES = DEFAULT_VALUES;
var CAMPUS_PROGRAMS_DEFAULT = [
    {
        id: 1,
        name: "Chula Vista",
        code: "Chula Vista",
        address: "CA 970 Broadway, Suite 110",
        state: "Chula Vista, CA 91911",
        phone: "619-474-6607",
        school_code: "3700511",
        addittional: {
            state: "California",
            region: "San Diego"
        },
        programs: [
            {
                id: 1,
                name: "Barbering",
                code: "Barbering"
            },
            {
                id: 2,
                name: "Barbering/Cosmetology",
                code: "Barbering/Cosmetology"
            },
            {
                id: 3,
                name: "Barbering/Cosmetology 102",
                code: "Barbering/Cosmetology 102"
            },
            {
                id: 4,
                name: "Cosmetology",
                code: "Cosmetology"
            },
            {
                id: 5,
                name: "Cosmetology 102",
                code: "Cosmetology 102"
            },
            {
                id: 8,
                name: "Esthetics / Esthetician",
                code: "Esthetics / Esthetician"
            },
            {
                id: 9,
                name: "Esthetics 102 / Esthetician 102",
                code: "Esthetics 102 / Esthetician 102"
            },
            {
                id: 10,
                name: "Esthetics 103 / Esthetician 103",
                code: "Esthetics 103 / Esthetician 103"
            },
            {
                id: 11,
                name: "Spa Nail Technician",
                code: "Spa Nail Technician"
            },
            {
                id: 12,
                name: "Makeup Artistry",
                code: "Makeup Artistry"
            }
        ]
    },
    {
        id: 2,
        name: "Poway",
        code: "Poway",
        address: "CA 13266 Poway Rd",
        state: "Poway, CA 92064",
        phone: "858-748-1490",
        school_code: "3707561",
        addittional: {
            state: "California",
            region: "San Diego"
        },
        programs: [
            {
                id: 1,
                name: "Barbering",
                code: "Barbering"
            },
            {
                id: 2,
                name: "Barbering/Cosmetology",
                code: "Barbering/Cosmetology"
            },
            {
                id: 3,
                name: "Barbering/Cosmetology 102",
                code: "Barbering/Cosmetology 102"
            },
            {
                id: 4,
                name: "Cosmetology",
                code: "Cosmetology"
            },
            {
                id: 5,
                name: "Cosmetology 102",
                code: "Cosmetology 102"
            },
            {
                id: 8,
                name: "Esthetics / Esthetician",
                code: "Esthetics / Esthetician"
            },
            {
                id: 9,
                name: "Esthetics 102 / Esthetician 102",
                code: "Esthetics 102 / Esthetician 102"
            },
            {
                id: 10,
                name: "Esthetics 103 / Esthetician 103",
                code: "Esthetics 103 / Esthetician 103"
            },
            {
                id: 11,
                name: "Spa Nail Technician",
                code: "Spa Nail Technician"
            },
            {
                id: 12,
                name: "Makeup Artistry",
                code: "Makeup Artistry"
            }
        ]
    },
    {
        id: 3,
        name: "El Cajon",
        code: "El Cajon",
        address: "CA 1073 E. Main St",
        state: "El Cajon, CA 92021",
        phone: "619-442-3407",
        school_code: "3700531",
        addittional: {
            state: "California",
            region: "San Diego"
        },
        programs: [
            {
                id: 2,
                name: "Barbering/Cosmetology",
                code: "Barbering/Cosmetology"
            },
            {
                id: 3,
                name: "Barbering/Cosmetology 102",
                code: "Barbering/Cosmetology 102"
            },
            {
                id: 4,
                name: "Cosmetology",
                code: "Cosmetology"
            },
            {
                id: 5,
                name: "Cosmetology 102",
                code: "Cosmetology 102"
            },
            {
                id: 8,
                name: "Esthetics / Esthetician",
                code: "Esthetics / Esthetician"
            },
            {
                id: 9,
                name: "Esthetics 102 / Esthetician 102",
                code: "Esthetics 102 / Esthetician 102"
            },
            {
                id: 10,
                name: "Esthetics 103 / Esthetician 103",
                code: "Esthetics 103 / Esthetician 103"
            },
            {
                id: 12,
                name: "Makeup Artistry",
                code: "Makeup Artistry"
            }
        ]
    },
    {
        id: 4,
        name: "Manhattan",
        code: "Manhattan",
        address: "KS 1130 Westloop Pl",
        state: "Manhattan, KS 66502",
        phone: "785-539-1837",
        school_code: "",
        addittional: {
            state: "Kansas",
            region: "Manhattan"
        },
        programs: [
            {
                id: 4,
                name: "Cosmetology",
                code: "Cosmetology"
            },
            {
                id: 5,
                name: "Cosmetology 102",
                code: "Cosmetology 102"
            },
            {
                id: 8,
                name: "Esthetics / Esthetician",
                code: "Esthetics / Esthetician"
            },
            {
                id: 9,
                name: "Esthetics 102 / Esthetician 102",
                code: "Esthetics 102 / Esthetician 102"
            },
            {
                id: 11,
                name: "Spa Nail Technician",
                code: "Spa Nail Technician"
            },
            {
                id: 12,
                name: "Makeup Artistry",
                code: "Makeup Artistry"
            },
            {
                id: 13,
                name: "Massage Therapy",
                code: "Massage Therapy"
            }
        ]
    }
];
exports.CAMPUS_PROGRAMS_DEFAULT = CAMPUS_PROGRAMS_DEFAULT;
//# sourceMappingURL=data:application/json;base64,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